import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Input,
  Select,
  message,
  DatePicker,
} from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleCreateTraining } from "../../../api/training";
import { handleFetchCompanyUser } from "../../../api/user";
import { useContext, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleFetchCourses } from "../../../api/course";
import moment from "moment";

const { Option } = Select;

export default function AddTraining({ isVisible, setVisible, trainings }: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const { auth } = useContext(AuthContext);
  const [data, setData] = useState<any>({});

  const { data: users } = useQuery({
    queryKey: ["users", auth?.company?._id],
    queryFn: () => handleFetchCompanyUser({ _id: auth?.company?._id }),
  });

  const { data: courses } = useQuery({
    queryKey: ["courses"],
    queryFn: handleFetchCourses,
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleCreateTraining,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["allTrainings"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      date: values?.start,
      ...values,
    };

    await mutate(data);
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const handleSelected = async () => {
    const { user_id } = form.getFieldsValue();
    const selected = users?.payload?.filter(
      (item: any) => item?._id === user_id
    );
    if (selected) {
      setData({
        name: selected[0]?.name,
        email: selected[0]?.email,
        mobile: selected[0]?.mobile,
        company: selected[0]?.company,
        user: user_id,
      });
    }
  };

  const userOptions = users?.payload?.map((level: any, index: number) => (
    <Option value={level?._id} key={index}>
      {level?.name}
    </Option>
  ));

  const trainingOptions = trainings?.map((training: any, index: number) => (
    <Option value={training?._id} key={index}>
      {training?.title}
    </Option>
  ));

  const courseOptions = courses?.payload?.map((course: any, index: number) => (
    <Option value={course?._id} key={index}>
      {course?.name}
    </Option>
  ));

  return (
    <Modal
      open={isVisible}
      title="Create Training"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createTraining"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createTraining"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="title"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <Input type="" placeholder="Title" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="start"
              label="Start date"
              rules={[
                {
                  required: true,
                  message: "Please enter start date",
                },
              ]}
            >
              <DatePicker
                className="w-full"
                format={"DD/MM/YYYY"}
                disabledDate={(current) => {
                  let customDate = moment().format("YYYY-MM-DD");
                  return current && current < moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="end"
              label="End date"
              rules={[
                {
                  required: true,
                  message: "Please enter end date",
                },
              ]}
            >
              <DatePicker
                className="w-full"
                format={"DD/MM/YYYY"}
                disabledDate={(current) => {
                  let customDate = moment().format("YYYY-MM-DD");
                  return current && current < moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="course"
              label="Course"
              rules={[
                {
                  required: true,
                  message: "Please select course",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Course"
                optionFilterProp="children"
                onSelect={() => handleSelected()}
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {courseOptions}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="organizer"
              label="Organizer"
              rules={[
                {
                  required: true,
                  message: "Please select organizer",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Organizer"
                optionFilterProp="children"
                onSelect={() => handleSelected()}
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="dependance"
              label="Related Training ( Optional )"
              rules={[
                {
                  required: false,
                  message: "Please select training",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Training"
                optionFilterProp="children"
                onSelect={() => handleSelected()}
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {trainingOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
